import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mr-1" }

import { computed } from 'vue'


export default {
  __name: 'ReportDelta',
  props: {
  delta: { type: Number, default: null },
  deltaInverted: { type: Boolean, default: false },
  deltaUnit: { type: String, default: 'percent' } // 'percent' | 'pp'
},
  setup(__props) {

const props = __props

const deltaLabel = computed(() => {
  if (props.deltaUnit === 'pp') return `${Math.round(Math.abs(props.delta))}pp`
  return `${Math.round(Math.abs(props.delta) * 100)}%`
})

const deltaClass = computed(() => {
  if (props.delta === null) return 'text-gray-500'
  const isPositiveDirection = props.deltaInverted ? props.delta < 0 : props.delta >= 0
  return isPositiveDirection ? 'text-green-600' : 'text-red-600'
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(deltaClass.value)
  }, [
    (__props.delta === null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "—"))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.delta >= 0 ? '↑' : '↓'), 1),
          _createElementVNode("span", null, _toDisplayString(deltaLabel.value), 1)
        ], 64))
  ], 2))
}
}

}